module.exports = __webpack_public_path__ + "img/54.5695b291.png";